module.exports = __webpack_public_path__ + "static/media/BannerRegistroMobileEN.bf272aa1.jpg";